import RequiredCredentials from './RequiredCredentials';
export default RequiredCredentials;
